import types from '../types'
import Action from '../../types/Action'

const initialState = {
  loading: true,
  data: [],
  error: false,
  success: false
}

const providerServiceReducer = (state = initialState, action: Action) => {
  switch (action.type) {
	  case types.GET_SERVICES_REQUESTED: {
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        data: []
      }
    }
    case types.GET_SERVICES_FULFILLED: {
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload
      }
    }
	  case types.GET_SERVICES_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default providerServiceReducer